























export default {
    "name": "ConnectionInfo"
    "props": {
        "connection":Object
        "title":false
        "opened": false
    }
    "computed":{}
    "data": ()->
        show: false or this.opened
    "methods":
        "toggle": ()->
            @show = !@show
        "copyPass": ()->
            el = this.$refs.pass
            console.log(el)        
            el.select()
            document.execCommand( 'copy' ) 
            this.$store.dispatch("notify",{
                level: "success",
                text: "Copié!",
                seconds: 2
            })
}
